export const INITIAL_STATE = {
    user: {},
    getcurrentUserIsLoading: false,
    getcurrentUserErrors: null,
    saveIsLoading: false,
    saveErrors: null,
    registerIsLoading: false,
    registerErrors: null,
    redirectTo: null,
    token: null,
    currentUser: {},
    inProgress: false,
    loginIsLoading: false,
    loginErrors: null,
}